import { BranchesOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { Tag, Tooltip } from 'antd'
import { FC } from 'react'
import PrintQueueEntry from '../../../../../../../../types/api/print-queue-entry'

interface RelationsCellProps {
    printQueueEntries?: PrintQueueEntry[]
    currentEntry: PrintQueueEntry
    conflictMessage?: string
}

const RelationsCell: FC<RelationsCellProps> = ({
    printQueueEntries = [],
    currentEntry,
    conflictMessage,
}) => {
    const relatedEntries = printQueueEntries
        .filter(entry => entry.documentId !== currentEntry.documentId)
        .sort((a, b) => a.sort - b.sort)

    if (relatedEntries.length === 0 && !conflictMessage) {
        return null
    }

    return (
        <div>
            {relatedEntries.length > 0 ? (
                <Tooltip
                    title={
                        <>
                            {relatedEntries.map(entry => (
                                <div key={entry.documentId}>
                                    {entry.machine?.name || 'Станок'} — №{' '}
                                    {entry.print_job?.id || currentEntry.print_job?.id || '—'}
                                </div>
                            ))}
                        </>
                    }
                >
                    <Tag style={{ fontSize: '12px' }} bordered={false} color={'gold'}>
                        {relatedEntries.length} <BranchesOutlined />
                    </Tag>
                </Tooltip>
            ) : null}

            {conflictMessage ? (
                <Tooltip title={conflictMessage}>
                    <Tag style={{ fontSize: '12px' }} bordered={false} color={'error'}>
                        <ExclamationCircleOutlined />
                    </Tag>
                </Tooltip>
            ) : null}
        </div>
    )
}

export default RelationsCell
